var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { attrs: { title: _vm.title } },
    [
      _vm.summaryOnly
        ? _c("div", [
            _c("div", { staticClass: "summary" }, [
              _c("p", [
                _c("strong", [_vm._v("Users:")]),
                _vm._v(
                  " " +
                    _vm._s((_vm.report.users && _vm.report.users.length) || 0)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Teams:")]),
                _vm._v(
                  " " +
                    _vm._s(
                      (_vm.report.contracts && _vm.report.contracts.length) || 0
                    )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Messages:")]),
                _vm._v(" " + _vm._s(_vm.report.messages.length))
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Average Sentiment:")]),
                _vm._v(" " + _vm._s(_vm.report.sentiment.toFixed(2)))
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("MTTA:")]),
                _vm._v(" " + _vm._s(_vm.formatTime(_vm.report.mtta)))
              ])
            ])
          ])
        : _c(
            "div",
            { staticClass: "row" },
            [
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _vm.report.users && _vm.report.users.length
                  ? _c("div", [
                      _c("div", { staticClass: "card" }, [
                        _c("h4", [
                          _vm._v("\n            Humans\n            "),
                          _c("span", { staticClass: "user-count" }, [
                            _vm._v(_vm._s(_vm.report.users.length))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "dl",
                          [
                            _vm._l(_vm.report.users, function(user) {
                              return [
                                _c("dt", { key: "user-" + user.user }, [
                                  _vm._v(_vm._s(user.user))
                                ]),
                                _vm._v(" "),
                                _c("dd", { key: "count-" + user.user }, [
                                  _vm._v(_vm._s(user.count))
                                ])
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _vm.report.contracts && _vm.report.contracts.length
                  ? _c("div", [
                      _c("div", { staticClass: "card" }, [
                        _c("h4", { staticClass: "teams" }, [
                          _vm._v("\n            Teams\n            "),
                          _c("span", { staticClass: "contract-count" }, [
                            _vm._v(_vm._s(_vm.report.contracts.length))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "dl",
                          [
                            _vm._l(_vm.report.contracts, function(contract) {
                              return [
                                _c(
                                  "dt",
                                  {
                                    key: "contract-" + contract.contract,
                                    staticClass: "contracts",
                                    class: {
                                      "hover-contract":
                                        _vm.hoverContract === contract.contract,
                                      "inactive-contract":
                                        _vm.hoverContract &&
                                        _vm.hoverContract !== contract.contract
                                    },
                                    on: {
                                      mouseover: function($event) {
                                        _vm.hoverContract = contract.contract
                                      },
                                      mouseout: function($event) {
                                        _vm.hoverContract = null
                                      },
                                      click: function($event) {
                                        return _vm.updateContract(
                                          contract.contract
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(contract.contract) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "dd",
                                  { key: "count-" + contract.contract },
                                  [_vm._v(_vm._s(contract.count))]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _vm.report.messages.length
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          class: {
                            positive:
                              _vm.report.sentiment > _vm.sentimentThreshold,
                            negative:
                              _vm.report.sentiment < _vm.sentimentThreshold
                          }
                        },
                        [
                          _c("h4", [_vm._v("Responsiveness")]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("MTTA")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.formatTime(_vm.report.mtta)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "spacer" }),
                          _vm._v(" "),
                          _c("h4", [_vm._v("Sentiment")]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("Score")]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.report.sentiment.toFixed(2)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "spacer" }),
                          _vm._v(" "),
                          _vm.report.topics.length
                            ? _c("h4", [_vm._v("Words")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report.topics, function(topic) {
                                return [
                                  _c("dt", { key: "topic-" + topic.topic }, [
                                    _vm._v(_vm._s(topic.topic))
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", { key: "count-" + topic.topic }, [
                                    _vm._v(_vm._s(topic.count))
                                  ])
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
      _vm._v(" "),
      !_vm.summaryOnly
        ? _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "transition-group",
                { attrs: { name: "list", appear: "" } },
                _vm._l(_vm.report.messages, function(message) {
                  return _c(
                    "div",
                    {
                      key: message.timestamp,
                      staticClass: "card",
                      class: {
                        positive: _vm.sentimentPositive(message.sentiment),
                        negative: _vm.sentimentNegative(message.sentiment),
                        neutral: _vm.sentimentNeutral(message.sentiment)
                      }
                    },
                    [
                      _c("h5", [
                        _vm._v(
                          "\n          " + _vm._s(message.user) + "\n          "
                        ),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimestamp(message.timestamp, _vm.period)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(message.message))]),
                      _vm._v(" "),
                      message.ack_ts > 0
                        ? _c("div", { staticClass: "ack" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.calcAckTime(
                                    message.timestamp,
                                    message.ack_ts
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass:
            "inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
          attrs: { to: "/" + _vm.id + "/base2bot" }
        },
        [
          _vm._v("\n  View Detailed Slack Report\n  "),
          _c(
            "svg",
            {
              staticClass: "ml-2 h-4 w-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }
            },
            [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7117da9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7117da9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/SlackCard.vue
// module id = null
// module chunks = 